import { render, staticRenderFns } from "./QueriesListItem.vue?vue&type=template&id=4a2a7c76"
import script from "./QueriesListItem.vue?vue&type=script&lang=js"
export * from "./QueriesListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports